import { createPortal } from 'react-dom'

import { Modal } from 'react-bootstrap'
import Select from 'react-select'
import Datetime from 'react-datetime'
import { KTSVG } from '_metronic/helpers'

import useViewModel from './ViewModel'
import moment from 'moment'
import { findReactSelectOption } from 'Utils/findReactSelectOption'
import { ISSUE_TYPES_OPTIONS, ISSUE_FORM_TYPE_OPTIONS } from 'Configuration/Paco'

const STATUS_OPTIONS = ISSUE_TYPES_OPTIONS.map(item => ({
  label: item,
  value: item,
}))

const MaintenanceFormModal: React.FC = () => {
  const {
    isView,
    isOpenMaintenanceModal,
    formType,
    handleClose,
    modalsRoot,
    formik,
    saleOrder,
    isValidEndDate,
  } = useViewModel()

  const saleOrderOptions = saleOrder.map(item => ({
    label: `${item.code}`,
    value: item.id,
  }))

  return createPortal(
    <Modal
      id='kt_modal_maintenance_form'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-lg modal-dialog-centered mw-900px'
      show={isOpenMaintenanceModal}
      onHide={handleClose}
      backdrop={true}>
      <div className='modal-content'>
        <div className='modal-header'>
          <h2 className='mb-0'>
            {isView
              ? 'รายละเอียดรายการแจ้งซ่อมบำรุง'
              : formType === 'add'
              ? 'เพิ่มรายการแจ้งซ่อมบำรุง / รายการลาหยุดพนักงาน'
              : 'แก้ไขรายการแจ้งซ่อมบำรุง / รายการลาหยุดพนักงาน'}
          </h2>
          {/* begin::Close */}
          <div className='btn btn-sm btn-icon btn-active-light-danger' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/general/gen040.svg' />
          </div>
          {/* end::Close */}
        </div>

        <form
          onSubmit={(e: any) => {
            formik.handleSubmit(e)
            e.preventDefault()
          }}>
          <div className='modal-body py-lg-10 px-lg-10 min-h-500px'>
            <div className='row gy-3'>
              {/* begin:: Sale Order */}
              <div className='col-12 col-xl-4'>
                <label htmlFor='name' className='fs-6 mb-3'>
                  Sale Order
                  <span className='required' />
                </label>

                <Select
                  name='saleOrderId'
                  isSearchable={true}
                  styles={{
                    control: (provided: any) => ({
                      ...provided,
                      borderColor: '#e1e3ea',
                    }),
                  }}
                  options={saleOrderOptions}
                  onBlur={formik.getFieldProps('saleOrderId').onBlur}
                  onChange={(selectedOption: any) => {
                    if (selectedOption) formik.setFieldValue('saleOrderId', selectedOption.value)
                  }}
                  value={findReactSelectOption({
                    value: formik.getFieldProps('saleOrderId').value,
                    options: saleOrderOptions,
                  })}
                />

                {/* {(formik.touched.saleOrderId || formik.errors.saleOrderId) && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>{formik.errors.saleOrderId}</div>
                  </div>
                )} */}
              </div>
              {/* end:: Sale Order */}

              {/* begin:: Department Name */}
              <div className='col-12 col-xl-8'>
                <label htmlFor='name' className='fs-6 mb-3'>
                  ชื่อหน่วยงาน
                  <span className='required' />
                </label>

                <input
                  disabled
                  value={
                    saleOrder.find(s => s.id === formik.getFieldProps('saleOrderId').value)
                      ?.division ?? ''
                  }
                  className='form-control form-control-sm'
                />
              </div>
              {/* end:: Department Name */}

              {/* begin:: Reporter */}
              <div className='col-12 col-xl-6'>
                <label htmlFor='name' className='fs-6 mb-3'>
                  รายงานจาก
                  <span className='required' />
                </label>

                <input
                  {...formik.getFieldProps('problemReportBy')}
                  className='form-control form-control-sm'
                />

                {(formik.touched.problemReportBy || formik.errors.problemReportBy) && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>{formik.errors.problemReportBy}</div>
                  </div>
                )}
              </div>
              {/* end:: Reporter */}

              {/* begin:: Time */}
              <div className='col-12 col-xl-6'>
                <label htmlFor='name' className='fs-6 mb-3'>
                  วัน/เดือน/ปี
                  <span className='required' />
                </label>

                <Datetime
                  timeFormat={false}
                  dateFormat='DD/MM/YYYY'
                  renderInput={props => (
                    <input
                      {...props}
                      autoComplete='off'
                      name='problemReportAt'
                      className='form-control form-control-sm'
                      onBlur={formik.getFieldProps('problemReportAt').onBlur}
                    />
                  )}
                  onChange={selectedDate => {
                    if (selectedDate)
                      formik.setFieldValue('problemReportAt', moment(selectedDate).toDate())
                  }}
                  value={formik.getFieldProps('problemReportAt').value}
                />

                {formik.touched.problemReportAt && formik.errors.problemReportAt && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>{formik.errors.problemReportAt as any}</div>
                  </div>
                )}
              </div>
              {/* end:: Time */}

              {/* begin:: Issue Category */}
              <div className='col-12 col-xl-4'>
                <label htmlFor='name' className='fs-6 mb-3'>
                  หมวดหมู่
                  <span className='required' />
                </label>

                {/* <input
                  {...formik.getFieldProps('issueCategory')}
                  className='form-control form-control-sm'
                /> */}
                <Select
                  name='issueCategory'
                  isSearchable={true}
                  styles={{
                    control: (provided: any) => ({
                      ...provided,
                      borderColor: '#e1e3ea',
                    }),
                  }}
                  options={ISSUE_FORM_TYPE_OPTIONS}
                  value={findReactSelectOption({
                    value: formik.getFieldProps('issueCategory').value,
                    options: ISSUE_FORM_TYPE_OPTIONS,
                  })}
                  onBlur={formik.getFieldProps('issueCategory').onBlur}
                  onChange={(selectedOption: any) => {
                    if (selectedOption) formik.setFieldValue('issueCategory', selectedOption.value)
                  }}
                />

                {(formik.touched.issueCategory || formik.errors.issueCategory) && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>{formik.errors.issueCategory}</div>
                  </div>
                )}
              </div>
              {/* end:: Issue Category */}

              {/* begin:: Issue Category */}
              <div className='col-12 col-xl-4'>
                <label htmlFor='name' className='fs-6 mb-3'>
                  ปัญหา
                  <span className='required' />
                </label>

                <input
                  {...formik.getFieldProps('issueTitle')}
                  className='form-control form-control-sm'
                />

                {(formik.touched.issueTitle || formik.errors.issueTitle) && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>{formik.errors.issueTitle}</div>
                  </div>
                )}
              </div>
              {/* end:: Issue Category */}

              {/* begin:: Machine Type */}
              <div className='col-12 col-xl-4'>
                <label htmlFor='machineTitle' className='fs-6 mb-3'>
                  ชนิดเครื่องจักร/ขนส่ง อื่นๆ
                </label>

                <input
                  {...formik.getFieldProps('machineTitle')}
                  className='form-control form-control-sm'
                />

                {(formik.touched.machineTitle || formik.errors.machineTitle) && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>{formik.errors.machineTitle}</div>
                  </div>
                )}
              </div>
              {/* end:: Machine Type */}

              {/* begin:: Status */}
              <div className='col-12 col-xl-4'>
                <label htmlFor='name' className='fs-6 mb-3'>
                  สถานะ
                  <span className='required' />
                </label>

                <Select
                  name='jobStatus'
                  isSearchable={true}
                  styles={{
                    control: (provided: any) => ({
                      ...provided,
                      borderColor: '#e1e3ea',
                    }),
                  }}
                  options={STATUS_OPTIONS}
                  onBlur={formik.getFieldProps('jobStatus').onBlur}
                  onChange={(selectedOption: any) => {
                    if (selectedOption) formik.setFieldValue('jobStatus', selectedOption.value)
                  }}
                  value={findReactSelectOption({
                    value: formik.getFieldProps('jobStatus').value,
                    options: STATUS_OPTIONS,
                  })}
                />

                {(formik.touched.jobStatus || formik.errors.jobStatus) && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>{formik.errors.jobStatus}</div>
                  </div>
                )}
              </div>
              {/* end:: Status */}

              {/* begin:: Start Time */}
              <div className='col-12 col-xl-4'>
                <label htmlFor='name' className='fs-6 mb-3'>
                  เวลาเริ่ม
                  <span className='required' />
                </label>

                <Datetime
                  timeFormat={'HH:mm'}
                  dateFormat='DD/MM/YYYY'
                  renderInput={props => (
                    <input
                      {...props}
                      autoComplete='off'
                      name='startPeriod'
                      className='form-control form-control-sm'
                      onBlur={formik.getFieldProps('startPeriod').onBlur}
                    />
                  )}
                  onChange={selectedDate => {
                    if (selectedDate)
                      formik.setFieldValue('startPeriod', moment(selectedDate).toDate())
                  }}
                  value={formik.getFieldProps('startPeriod').value}
                />

                {formik.touched.startPeriod && formik.errors.startPeriod && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>{formik.errors.startPeriod}</div>
                  </div>
                )}
              </div>
              {/* end:: Start Time */}

              {/* begin:: Finish Time */}
              <div className='col-12 col-xl-4'>
                <label htmlFor='name' className='fs-6 mb-3'>
                  เวลาสิ้นสุด
                </label>

                <Datetime
                  timeFormat={'HH:mm'}
                  dateFormat='DD/MM/YYYY'
                  renderInput={props => (
                    <input
                      {...props}
                      autoComplete='off'
                      name='endPeriod'
                      className='form-control form-control-sm'
                      onBlur={formik.getFieldProps('endPeriod').onBlur}
                    />
                  )}
                  onChange={selectedDate => {
                    if (selectedDate)
                      formik.setFieldValue('endPeriod', moment(selectedDate).toDate())
                  }}
                  value={formik.getFieldProps('endPeriod').value}
                  isValidDate={isValidEndDate}
                />

                {formik.touched.endPeriod && formik.errors.endPeriod && (
                  <div className='fv-plugins-message-container mt-2'>
                    <div className='fv-help-block'>{formik.errors.endPeriod}</div>
                  </div>
                )}
              </div>
              {/* end:: Start Time */}

              {/* begin:: Remark */}
              <div className='col-12'>
                <label htmlFor='name' className='fs-6 mb-3'>
                  หมายเหตุเพิ่มเติม
                  <span className='required' />
                </label>

                <textarea
                  {...formik.getFieldProps('remark')}
                  className='form-control form-control-sm'
                  rows={5}
                />
              </div>
              {/* end:: Remark */}
            </div>
          </div>

          <div className='modal-footer'>
            {!isView && (
              <div
                className='col-12 d-flex flex-row justify-content-end'
                style={{ columnGap: '12px' }}>
                <button
                  type='reset'
                  className='btn btn-sm btn-light fw-bolder'
                  onClick={handleClose}
                  disabled={formik.isSubmitting}>
                  ยกเลิก
                </button>
                <button
                  type='submit'
                  className='btn btn-sm btn-success me-4 fw-bold'
                  disabled={formik.isSubmitting || !formik.isValid}>
                  บันทึก
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
    </Modal>,
    modalsRoot
  )
}

export default MaintenanceFormModal
